import { Component } from "@angular/core";
import { CustomCookieServiceService } from "../../services/custom-cookie-service.service";
import { AuthService } from "../../services/auth.service";
import { PopupService } from "../../services/popup.service";

import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-ios-pwa-install-dialog",
  imports: [TranslateModule],
  templateUrl: "./ios-pwa-install-dialog.component.html",
  styleUrl: "./ios-pwa-install-dialog.component.scss",
})
export class IosPwaInstallDialogComponent {
  constructor(
    private cookieService: CustomCookieServiceService,
    private authService: AuthService,
    private popupService: PopupService,
  ) {}

  maybeLater() {
    // Set expiration: 90 days for students, 30 days for tutors
    const expirationDays = this.authService.isTeacher() ? 30 : 90;
    this.cookieService.put("pwa-install-dismissed", "true", {
      expires: expirationDays,
      path: "/",
      sameSite: "Lax",
    });
    this.popupService.onClose.emit();
  }
}
